import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const paymentService = {
  getPaymentInfo: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.getPaymentInfo,
      payload,
      headers,
      hasErrorHandler,
    }),

  getReissuePaymentInfo: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.getReissuePaymentInfo,
      payload,
      headers,
      hasErrorHandler,
    }),

  applyCoponCode: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.applyCoponCode,
      payload,
      headers,
      hasErrorHandler,
    }),
  applyCoponCodeExceptFlight: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.applyCoponCodeExceptFlight,
      payload,
      headers,
      hasErrorHandler,
    }),
  removeCoponCode: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.removeCoponCode,
      payload,
      headers,
      hasErrorHandler,
    }),
  removeCoponCodeExceptFlight: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.removeCoponCodeExceptFlight,
      payload,
      headers,
      hasErrorHandler,
    }),
  getSavedCards: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.getSavedCards,
      payload,
      headers,
      hasErrorHandler,
    }),

  applyTurnaPoints: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.applyTurnaPoints,
      payload,
      headers,
      hasErrorHandler,
    }),
  getAllInstalments: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.getAllInstalments,
      payload,
      headers,
      hasErrorHandler,
    }),

  threeDPaymentWithStoredCard: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.init3dPaymentWithStoredCard,
      payload,
      headers,
      hasErrorHandler,
    }),
  threeDPaymentWithNewCard: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.init3dPaymentWithNewCard,
      payload,
      headers,
      hasErrorHandler,
    }),

  makeReissueInit3d: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.makeReissueInit3d,
      payload,
      headers,
      hasErrorHandler,
    }),

  reissueOfferCheckout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.reissueOfferCheckout,
      payload,
      headers,
      hasErrorHandler,
    }),

  getStoredCards: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.getStoredCards,
      payload,
      headers,
      hasErrorHandler,
    }),
  completePayment: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.completePayment,
      payload,
      headers,
      hasErrorHandler,
    }),

  getUsabledCampaigns: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.getUsabledCampaigns,
      payload,
      headers,
      hasErrorHandler,
    }),

  getBinDetails: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.getBinDetails,
      payload,
      headers,
      hasErrorHandler,
    }),

  getBinDetailsByCardNumber: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.getBinDetailsByCardNumber,
      payload,
      headers,
      hasErrorHandler,
    }),

  payWithTurnaPoints: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.payWithTurnaPoints,
      payload,
      headers,
      hasErrorHandler,
    }),

  makePointPayment: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.flight.makePointPayment,
      payload,
      headers,
      hasErrorHandler,
    }),

  getPaymentConfiguration: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: API_URLS.payment.getPaymentConfiguration,
      payload,
      headers,
      hasErrorHandler,
    }),

  carDeliveryPayment: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.carDeliveryPayment,
      payload,
      headers,
      hasErrorHandler,
    }),
  saveCreditCardFromSession: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.payment.saveCreditCardFromSession,
      payload,
      headers,
      hasErrorHandler,
    }),
};
